// Date demo — înlocuiește cu datele reale ale școlii Auto Valy Drive
export const SITE = {
  name: "Auto Valy Drive",
  city: "Pașcani",
  phoneDisplay: "0742 412 536",
  phoneRaw: "+40742412536",
  whatsapp: "40742412536", // format internațional fără +
  email: "contact@autovaly.ro",
  address: "Str. Izvoarelor, Bl. D13, Pașcani, jud. Iași",
  mapsQuery: "Str. Izvoarelor D13, Pascani, Romania",
  schedule: "Luni – Sâmbătă: 08:00 – 20:00",
  social: {
    facebook: "https://www.facebook.com/profile.php?id=61556221601856",
    instagram: "https://instagram.com",
  },
};

export const buildWhatsAppLink = (message) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(message)}`;
